<div class="modus-footer d-flex align-items-center">
  <div class="small">
    © Copyright 2024, Trimble Inc. &nbsp;
    <a href="https://www.trimble.com/en/legal/privacy-notice" target="_blank" rel="noopener noreferrer"
      >Privacy Center</a
    >
  </div>
</div>
